module.exports = dormakaba.vendorTerrific['vendor/terrific'];